import { DefaultIcon } from '@summit/core';

import { HtmlToText } from '../string-functions';
import { SummitLink } from './summit-link';

export class SummitFormattedLine {
  //only Line or Key/Value should be used on a line
  iconArray?: DefaultIcon[];
  iconLeft?: DefaultIcon;

  entry?: string;
  isHtml?: boolean;
  key?: string;
  value?: string | number;
  valueClass?: string[];
  link?: SummitLink;

  get length(): number {
    if (this.key) return this.key.length + (this.value?.toString().length ?? 0);
    return this.entry?.length ?? 0;
  }

  public SetKeyValues(key: string, value: string | number) {
    this.key = key;
    this.value = value;
  }

  public toString() {
    if (this.key) return `${this.key}: ${this.value}`;
    if (this.isHtml && this.entry) return HtmlToText(this.entry);
    return this.entry ?? '';
  }
}
